export default __webpack_public_path__ + "static/media/NanumSquareL.5c6a24ab.eot";